export { default } from './StateText'
